import { MentionSearchFacetTypesEnum } from '../../mentions/enum/mention-search-facet-types.enum';

export enum GeographyTypesEnum {
    continent = 'Continent',
    country = 'Country',
    province = 'Province',
    county = 'County',
    city = 'City',
    other = 'Other',
    world = 'World'
}

export const geographyTypesEnumToDisplayString = new Map([
    [GeographyTypesEnum.continent, 'Common.continent'],
    [GeographyTypesEnum.country, 'Common.country'],
    [GeographyTypesEnum.province, 'Common.province'],
    [GeographyTypesEnum.county, 'Common.county'],
    [GeographyTypesEnum.city, 'Common.city'],
    // [GeographyTypesEnum.other, 'Other'], // What is this?
    [GeographyTypesEnum.world, 'Common.corld']
]);

export const geographyTypesEnumToGeographyMentionFacetTypesEnum  = new Map([
    [GeographyTypesEnum.continent, MentionSearchFacetTypesEnum.continent],
    [GeographyTypesEnum.country, MentionSearchFacetTypesEnum.country],
    [GeographyTypesEnum.province, MentionSearchFacetTypesEnum.province],
    [GeographyTypesEnum.city, MentionSearchFacetTypesEnum.city],
    [GeographyTypesEnum.county, MentionSearchFacetTypesEnum.county]
]);

export const geographyMentionFacetTypesToGeographyTypesEnum  = new Map([
    [MentionSearchFacetTypesEnum.continent, GeographyTypesEnum.continent],
    [MentionSearchFacetTypesEnum.country, GeographyTypesEnum.country],
    [MentionSearchFacetTypesEnum.province, GeographyTypesEnum.province],
    [MentionSearchFacetTypesEnum.city, GeographyTypesEnum.city],
    [MentionSearchFacetTypesEnum.county, GeographyTypesEnum.county]
]);
